<template>
  <div class="guide-video">
    <div class="main">
      <div class="gj-left">
        <span style="font-weight: 600;color: #333333;line-height: 28px;font-size: 18px;margin-top: 28px;display: inline-block">视频教程目录</span>
        <div style="margin-top: 20px;border-top: 1px solid rgba(228,229,230,1);margin-left: -40px">
          &nbsp;
        </div>
        <template v-for="item in videoList">
          <p :key="item.code">
            <span class="text" :class="{activeColor:item.active}" @click="toggleVideo(item)">{{ item.name }}</span>
          </p>
        </template>
      </div>
      <div class="gj-container">
        <h1 style="margin-top: 28px">{{ title }}</h1>
        <div>
          <video :src="videoSrc" width="760px" height="460px" style="object-fit: fill;" controls="controls" @ended="playEnd">
            您的浏览器不支持播放视频，请使用谷歌浏览器！
          </video>
        </div>
        <template v-for="item in dataList">
          <div :key="item.title">
            <span class="title">{{ item.title }}</span>
            <template v-for="(list,index) in item.textList">
              <el-row :key="index">
                <el-col :span="3"><span class="video-label">{{ list.label }}</span></el-col>
                <el-col :span="21" class="video-text"><span v-html="list.text"></span></el-col>
              </el-row>
            </template>
          </div>
        </template>
        <br><br>
      </div>
    </div>
  </div>
</template>

<script>
import {postFinishViewTask, postFinishHandleTask, getAllVideo} from "@/api/system";

export default {
  name: "guide-video",
  data() {
    return {
      initVideoList: [
        {
          code: 'MARKET', name: '店铺授权', active: true,
          dataList: [
            {
              title: '一、店铺授权，注意：请在安全的网络环境下进行授权，避免店铺关联！！！',
              textList: [
                {label: '视频时间：', text: '00:00 - 00:29'},
                {
                  label: '说明：',
                  text: '积加店铺绑定接口介绍：SP-API；<br>账号使用权限：具备店铺授权权限的账号才能关联店铺；<br>可关联店铺数：不限制;<br>ERP建议使用浏览器：谷歌;'
                },
                {label: '特别提示：', text: '数据同步说明：实时数据实时同步，历史数据三天内同步完成。'}
              ]
            },
            {
              title: '二、广告授权，注意：请在安全的网络环境下进行授权，避免店铺关联！！！',
              textList: [
                {label: '视频时间：', text: '00:30 - 01:02'},
                {label: '说明：', text: '数据同步：实时数据15-30分钟同步系统，历史数据三天内完成同步；'},
                {label: '特别提示：', text: '如果亚马逊后台没有开通广告则会授权失败！！！<br>近一个月内的广告数据会出现与亚马逊平台不一致的情况，因为数据还是在更新阶段;'}
              ]
            }
          ]
        },
        {
          code: 'USER', name: '账号管理', active: false,
          dataList: [
            {
              title: '一、团队使用的第一步，创建角色，防止数据外泄',
              textList: [
                {label: '视频时间：', text: '00:00-00:52'},
                {
                  label: '说明：', text: '1、设置角色的目的：<br>① 专人负责专项：可以根据部门所负责的事项精简系统功能展示，以免造成混乱<br>' +
                      '② 数据保护：系统支持收集并展示所有数据，部分数据对于公司管理层可能属于保密数据，可以防止数据外泄<br>2、如何安排角色：<br>① 根据公司部门分配：以部门创建角色，分配角色权限<br>' +
                      '② 根据环节分配：以仓库、采购、物流、销售等进出口环节创建角色，分配角色权限<br>③ 根据人员分配：人员可能需要负责多个环节，可灵活命名，创建角色，分配角色权限'
                },
              ]
            },
            {
              title: '二、创建了角色，赋予给用户，进行系统操作',
              textList: [
                {label: '视频时间：', text: '00:53-02:06'},
                {
                  label: '说明：', text: '1、设置用户账号的目的：<br>① 责任到人：系统可记录操作人，如果共用数据账号，需要找到责任人时就很难立即找到对应操作人；<br>' +
                      '② 便于内部管理：多店铺商家的运营人员以及采购、销售存在不一样的情况，系统支持用户与店铺进行绑定，方便员工操作；<br>③ 数据安全：绑定店铺的用户只能查看和操作绑定店铺的操作与数据；'
                },
                {label: '特别提示：', text: '① 目前可以支持创建多级部门，按卖家需要。<br>② 一个用户可以授权多个店铺，按卖家需要。<br>③ 一个用户可以拥有多个角色，按卖家需要。'}
              ]
            }
          ]
        },
        {
          code: 'PRODUCT', name: '产品管理', active: false,
          dataList: [
            {
              title: '一、维护品类资料，做好基础信息',
              textList: [
                {label: '视频时间：', text: '00:00 - 00:41'},
                {label: '说明：', text: '1、维护品类信息目的：<br>① 做好产品基础信息维护，创建产品直接选择；<br>② 进行销售分析时，更好对品牌表现进行数据分析'},
                {label: '特别提示：', text: '此品类非亚马逊品类，为企业内部品牌信息；'},
              ]
            },
            {
              title: '二、维护品牌资料，做好基础信息',
              textList: [
                {label: '视频时间：', text: '00:42 - 00:59'},
                {label: '说明：', text: '1、维护品牌信息目的：<br>① 对于品牌卖家，品牌信息为必备信息；<br>② 对于非品牌卖家，查看不同的品牌销售表现为必要分析点；'},
                {label: '特别提示：', text: '此品牌非亚马逊平台维护品牌信息，为企业内部品牌信息；'}
              ]
            },
            {
              title: '三、维护企业内部产品资料，更好的管理与分析产品表现',
              textList: [
                {label: '视频时间：', text: '01:00 - 03:44'},
                {
                  label: '说明：',
                  text: '1、维护产品资料的必要性：<br>① 当需要采购产品时，可以及时的选择；<br> ② 在销售时，亚马逊的销售产品与企业内部产品是会存在一定的差异性，维护自身的产品能更好的辅佐到卖家进行数据分析；'
                },
                {label: '特别提示：', text: '此产品非亚马逊平台销售产品，为企业内部品牌信息；'},
              ]
            }
          ]
        },
        {code: 'LISTING', name: '产品关联', active: false,
          dataList:[
            {
              title: '一、listing与产品关联，实现B、C两端数据联动',
              textList: [
                {label: '视频时间：', text: '00:00 - 00:50'},
                {
                  label: '说明：',
                  text: '1、产品关联的好处：<br>① 实现一个产品在多个店铺的管理；<br> ② 集中管理产品的采购成本和头程成本，核算利润；<br> ③ 可以基于采购、仓储、FBA发货补货等的统一管理，支撑FBA仓库和本地仓库的对应关系；'
                },
              ]
            }
          ]
        },
        {code: 'SUPPLIER', name: '供应商管理', active: false,
          dataList:[
            {
              title: '一、维护好供应商信息，采购下单分分钟',
              textList: [
                {label: '视频时间：', text: '供应商资料创建过程及注意事项：00:00-02:32'},
                {
                  label: '说明：',
                  text: '1、维护供应商资料的必要性：<br> ① 采购流程不可缺少的环节；<br> ② 维护供应商资料，报价，创建采购单自动带出产品价格；'
                },
              ]
            }
          ]
        },
        {code: 'WAREHOUSE', name: '仓库管理', active: false,
          dataList:[
            {
              title: '一、维护仓库信息，库存、出入库、调拨、装配尽在掌握',
              textList: [
                {label: '视频时间：', text: '00:00-00:42'},
                {
                  label: '说明：',
                  text: '1、维护仓库资料的必要性：<br> ① 仓库环节期初数据，必不可少的环节；<br> ② 可查看仓库库存或查看产品库存，清楚了解产品情况；<br> ③ 在产品流动环节，仓库为必填项；' +
                      '<br>2、维护仓库的好处：<br> ① 清楚了解产品的库龄；<br> ② 清楚了解产品库存货值；<br>③ 清楚了解仓库产品库存量，及时根据销量补充库存；'
                },
              ]
            }
          ]},
        {code: 'LOGISTICS', name: '物流商管理', active: false,
          dataList:[
            {
              title: '一、维护好物流商资料，让发货更顺畅',
              textList: [
                {label: '视频时间：', text: '00:00-01:33'},
                {
                  label: '说明：',
                  text: '1、维护物流商信息的必要性：<br> ① 录入头程费用就需要维护物流商资料；<br>2、维护物流商的好处：<br> ① 维护物流商资料，才能维护物流方式、时效、价格；'
                },
              ]
            },
            {
              title: '二、做好头程物流信息设置，货物时效、运输价格明明白白',
              textList: [
                {label: '视频时间：', text: '01:34-02:51'},
                {
                  label: '说明：',
                  text: '1、维护头程物流的必要性：<br> ① 用户发货到FBA仓时，根据需要选择不同的物流方式，所以发货到FBA仓前需要先维护好物流方式；<br>2、维护头程物流的好处：' +
                      '<br> ① 通过已发货国家、目的国家、时效维度展示物流方式数据，以便选择最佳物流方式；'
                },
              ]
            }
          ]},
          {code: 'COST', name: '成本维护', active: false,
            dataList:[
              {
                title: '一、维护产品的采购成本、到库成本，让每一笔钱的出处算的清清楚楚',
                textList: [
                  {label: '视频时间：', text: '00:00-03:21'},
                  {
                    label: '说明：',
                    text: '1、维护成本的好处：<br>  ① 根据成本计算方式，均摊每个月成本，清晰明确；<br>  ② 清楚了解每个月的固定支出，做持续性观察；'
                  },
                ]
              }
            ]
          },
          {code: 'PLUGIN', name: '插件安装', active: false,
            dataList:[
              {
                title: '一、安装插件，助力轻松分析数据',
                textList: [
                  {label: '视频时间：', text: '00:00-02:58'},
                  {
                    label: '说明：',
                    text: '安装插件的好处：<br> ①系统自动获取流量数据，让您可以在系统结合流量与销售数据同步分析；<br>  ②系统自动获取日期范围报告，生成利润报表，让您的财务利润核算更轻松；'
                  },
                ]
              }
            ]
          },
      ],
      videoList: [],
      dataList: [],
      code: 'MARKET',
      title: '',
      videoSrc: '',
      state: false,
    }
  },
  created() {
    this.getVideo()
  },
  methods: {
    getVideo() {
      getAllVideo().then(res => {
        if (res) {
          res.forEach(v => {
            this.initVideoList.forEach(item => {
              if (v.code === item.code) {
                v.name = item.name;
                v.text = item.text;
                v.dataList = item.dataList;
                v.active = window.location.href.includes(v.code);
                if (v.active) {
                  this.videoSrc = v.url;
                  this.code = item.code;
                  this.title = v.name;
                  this.dataList = v.dataList;
                }
              }
            })
          })
          this.videoList = res;
        }
      })
    },
    toggleVideo(item) {
      this.videoList.forEach(v => {
        v.active = false;
      })
      this.title = item.name;
      this.videoSrc = item.url;
      this.dataList = item.dataList;
      this.code = item.code;
      item.active = true;
    },
    // 判断是否有完成任务
    checkFinishHandleTask() {
      postFinishHandleTask().then(res => {})
    },
    // 视频播放完成
    playEnd() {
      this.checkFinishHandleTask();
      postFinishViewTask(this.code, 1).then(res => {})
    }
  },
}
</script>

<style scoped lang="scss">

.guide-video {
  background-color: #FFFFFF !important;
  height: 100%;

  .main {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
    overflow: auto;
    position: relative;
    .gj-left {
      margin-left: -260px;
      position: sticky;
      top: 0;
      margin-right: 40px;
      width: 180px;
      height: 100%;
      background: #F9F9FA;
      padding-left: 40px;
      border-right: 1px solid #e4e5e6;
      .text {
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        line-height: 20px;
        cursor: pointer;
      }
    }

    .gj-container {
      width: 760px;
      text-align: left;
      position: relative;
      .video-label {
        color: #333333;
        font-size: 14px;
        font-weight: 600;
      }

      .video-text {
        color: #666666;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        white-space:nowrap;
      }
      .title {
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        line-height: 25px;
        margin-top: 32px;
        margin-bottom: 16px;
      }
    }
  }

  .activeColor {
    color: #2B6DDE !important;
    font-weight: 600 !important;
  }
}
</style>
